<template>
    <Collapse v-if="list.length">
        <template slot="title">
            {{tab == SectionTabs.ROLE ? t('selectMember.role') : t('selectMember.roleMember')}}
        </template>
        <template slot="content">
            <RoleNode 
                v-for="(item, index) in list"
                :data="item"
                :key="index"
                :withMembers="tab == SectionTabs.ROLE_MEMBER"
                @handleExpand="handleExpand"
                @handleChecked="handleChecked"/>
            <Load v-if="hasMore" 
                :hasData="!!list.length"
                :hasMore="hasMore"
                :loading="loading" 
                @on-load="handleSearch"/>
        </template>
    </Collapse>
</template>

<script>
import Mixin from './mixin';
import { getRoleList, getRoleMemberList } from '../utils';
import RoleNode from '../section/section-role-node';

export default {
    name: "SearchRoleResult",
    mixins: [ Mixin ],
    components: {
        RoleNode
    },
    computed: {
        withMembers() {
            return this.tab === this.SectionTabs.ROLE_MEMBER
        },
    },
    data() {
        return {};
    },
    methods: {
        handleSearch() {
            this.loading = true;
            const { host, tenantId, language, keyword, token } = this.root;
            return getRoleList(host, tenantId, {
                keyword: keyword,
                page: this.page,
                size: this.size,
                language: language,
                token: token
            }).then(res => {
                const data = res.data
                if (!Array.isArray(data)) throw new Error();
                data.forEach(item => {
                    item.loading = false;
                    item.type = 6;
                    item.expand = false;
                    item.checked = false;
                    item.children = [];
                })
                this.list = this.list.concat(data);
                this.page ++;
                this.hasMore = data.length >= this.size;
            }).catch(err => {
                this.list = [];
                this.hasMore = true;
            }).finally(() => {
                this.loading = false;
            })
        },
        getMemberList(roleId, role, isSelect) {
            role && (role.loading = true)
            const { host, qzId, keyword, language, security, token, tenantId } = this.root
            getRoleMemberList(host, tenantId, qzId, roleId, {
                page: this.page,
                size: this.size,
                keyword: keyword || '',
                language: language,
                security: security,
                token: token,
                includeDuty: true
            }).then(res => {
                role.loading = false
                const data = res && res.data;
                data.forEach(member => {
                    member.checked = !!isSelect
                    if (isSelect) {
                        this.root.handleSelected(member)
                    }
                })
                this.$set(role, 'children', data)
            }).catch(err => {
                role.loading = false;
                role.expand = false;
            })
        },
        handleExpand(expand, data) {
            data.expand = expand
            if (data.children && data.children.length) return
            this.getMemberList(data.roleId, data, false)
        },
        handleChecked(checked, data) {
            if (data.loading) return false
            if (!this.withMembers || data.type === 0) {
                if (checked && 1 + this.root.selectedCount > this.root.limit && this.root.limit != 1) {
                    Message.warning(t('selectMember.maximum'))
                    return false
                }
                data.checked = checked
                this.root.handleSelected(data)
                return true
            }
            if (checked && data.groupMemberCount + this.root.selectedCount > this.root.limit) {
                Message.warning(t('selectMember.maximum'))
                return false
            }
            if (data.children && data.children.length) {
                data.checked = checked
                data.children.forEach((item) => {
                    item.checked = checked
                    this.root.handleSelected(item)
                })
                return true
            }
            data.expand = true
            this.getMemberList(data.roleId, data, true)
            return true
        }
    }
}
</script>

<style lang="less" scoped>

</style>